export default "__VITE_ASSET__xiSXz_Vr__"